import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/rootReducer";
import { RootModalState } from "./types";

const initialState: RootModalState = {
  modalType: "",
  modalProps: {},
};

const rootModal = createSlice({
  name: "rootModal",
  initialState,
  reducers: {
    showRootModal(state, action) {
      state.modalType = action.payload.modalType;
      state.modalProps = action.payload.modalProps;
    },
    hideRootModal(state) {
      state.modalType = "";
      state.modalProps = {};
    },
  },
});

export const { showRootModal, hideRootModal } = rootModal.actions;

export default rootModal.reducer;

export const selectModalType = (state: RootState) => state.rootModal.modalType;
export const selectModalProps = (state: RootState) =>
  state.rootModal.modalProps;
